import React from 'react';
import { motion } from 'framer-motion';
import { Connection, WordPosition } from '../types/game';
import { useGame } from '../context/GameContext';

interface ConnectionLinesProps {
  connections: Connection[];
  wordPositions: Record<string, WordPosition>;
}

const ConnectionLines: React.FC<ConnectionLinesProps> = ({ connections, wordPositions }) => {
  const { gameState } = useGame();

  return (
    <g className="connection-lines">
      {connections.map((connection, index) => {
        const fromPos = wordPositions[connection.from];
        const toPos = wordPositions[connection.to];
        
        if (!fromPos || !toPos || connection.color === 'transparent') {
          return null;
        }

        const isLastConnection = gameState.lastConnection === connection;
        const strokeWidth = isLastConnection ? 4 : (connection.isCorrect ? 4 : 1.5);
        
        // Determine color based on connection type
        let strokeColor = connection.color;
        if (connection.color === 'green') {
          strokeColor = '#10b981'; // Green for user's correct connections
        } else if (connection.color === 'gray' || connection.isRevealed) {
          strokeColor = '#9ca3af'; // Gray for revealed solution connections
        }

        return (
          <motion.line
            key={`${connection.from}-${connection.to}-${index}`}
            x1={fromPos.x}
            y1={fromPos.y}
            x2={toPos.x}
            y2={toPos.y}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            filter="drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
            initial={{ 
              pathLength: 0,
              opacity: 0,
            }}
            animate={{ 
              pathLength: 1,
              opacity: 1,
            }}
            transition={{
              pathLength: { duration: 0.5, ease: "easeInOut" },
              opacity: { duration: 0.3 },
            }}
          />
        );
      })}
    </g>
  );
};

export default ConnectionLines;